module.exports = __webpack_public_path__ + "img/_0001_图层-3.2cf0bdc2.png";